import router from "@/lib/router";
import menu from "@/lib/menu";
import i18n from "@/lib/i18n";
import breadcrumb from "@/lib/breadcrumb";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.uploads": "Dépôts de fichiers"
		});

		breadcrumb.add([
			{
				path: "/uploads",
				name: "home>uploads"
			}
		]);

		router.addRoutes([
			{
				name: "uploads",
				path: "/uploads",
				component: () => import("./vues/UploadedFilesCard.vue"),
				meta: {
					secured: true,
				}
			}
		]);

		menu.addEntry({
			label: i18n.t("breadcrumb.uploads") as string,
			icon: "fa fa-upload",
			location: {
				name: "uploads"
			},
			order: 1,
		});
	}
};
